import { useContext, useEffect, useState } from 'react'
import { IMessage } from '@stomp/stompjs'

import { PageContext } from '@pages/ConfiguredEntity/ConfiguredEntity'
import { getObjectCodeUrl } from '@pages/ConfiguredEntity/helpers'

import { useSubscription } from '@hooks'
import { DEFAULT_TIME_IN_SECONDS_FOR_UPDATE_INTERVAL, UPDATE_TYPE } from '@constants'
import { EntityType } from '@types'

import { useExecuteTimeout } from '../../../../../hooks/useExecuteTimeout'

export const useUpdateSettings = ({
  onObjectSubscribe,
  onRefreshAllPages,
  entity,
}: {
  onObjectSubscribe: (msg: IMessage) => Promise<void>
  onRefreshAllPages: () => void
  entity: EntityType
}) => {
  const [isUpdateSettingsOpen, setIsUpdateSettingsOpen] = useState(false)
  const [updateType, setUpdateType] = useState<UPDATE_TYPE>()
  const [updateInterval, setUpdateInterval] = useState<number>(
    entity.updateSetting?.interval || DEFAULT_TIME_IN_SECONDS_FOR_UPDATE_INTERVAL
  )

  const { handleSetLocalUpdateType } = useContext(PageContext)

  const handleToggleUpdateSettings = (value: boolean) => {
    setIsUpdateSettingsOpen(value)
  }

  // Обновление по сокету
  const [toggleSocket] = useSubscription(getObjectCodeUrl(entity.objectCode), onObjectSubscribe)

  // Обновление по таймауту
  const [toggleTimeout] = useExecuteTimeout(
    onRefreshAllPages,
    updateInterval * 1000,
    true,
    true,
    true
  )

  useEffect(() => {
    handleSwitchUpdateType(
      entity.updateSetting?.type || UPDATE_TYPE.WEBSOCKET,
      entity.updateSetting?.interval || DEFAULT_TIME_IN_SECONDS_FOR_UPDATE_INTERVAL
    )
  }, [])

  const handleSwitchUpdateType = (newUpdateType: UPDATE_TYPE, newUpdateInterval?: number) => {
    if (newUpdateInterval) {
      setUpdateInterval(newUpdateInterval)
    }

    if (newUpdateType === updateType) {
      return
    }

    switch (newUpdateType) {
      case UPDATE_TYPE.MANUAL:
        toggleTimeout(false)
        toggleSocket(false)
        break
      case UPDATE_TYPE.INTERVAL:
        toggleTimeout(true)
        toggleSocket(false)
        break
      case UPDATE_TYPE.WEBSOCKET:
      default:
        if (updateType !== undefined) {
          onRefreshAllPages()
        }
        toggleTimeout(false)
        toggleSocket(true)
        break
    }

    setUpdateType(newUpdateType)
    handleSetLocalUpdateType(newUpdateType)
  }

  return {
    state: {
      isUpdateSettingsOpen,
      updateType,
    },
    handlers: {
      handleToggleUpdateSettings,
      handleSwitchUpdateType,
    },
  }
}
